import React from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { employeeIsAllowed } from 'HelperFunctions/locations';
import { ORDERS_VIEW_PATH } from 'Utils/OrdersViewLink';

export const ADMIN_ONLY_ROLES = ['admin', 'owner'];

export const canViewAtAGlanceLink = (employeeLocationRelationship) => {
  return employeeIsAllowed(ADMIN_ONLY_ROLES, employeeLocationRelationship);
};

// Default landing page for the top-nav "Dashboard" button (and post-login
// redirect). At-A-Glance is admin-only and therefore optional; when it isn't
// available we land on the Orders View gantt instead of To-Do's.
export const getDashboardNavLinkPath = (employeeLocationRelationship) => {
  return canViewAtAGlanceLink(employeeLocationRelationship)
    ? '/at-a-glance'
    : ORDERS_VIEW_PATH;
};

const AtAGlanceLink = (canViewLink) => (props) => {
  const { employeeLocationRelationship, multilocationAllLocations } = props;

  if (multilocationAllLocations || !canViewLink(employeeLocationRelationship)) {
    return null;
  }

  return (
    <NavLink to='/at-a-glance' activeClassName='selected'>
      At-A-Glance
    </NavLink>
  );
};

const mapStateToProps = (state) => {
  const { employeeLocationRelationship } = state.user;
  const { multilocationAllLocations } = state.dashboard;

  return { employeeLocationRelationship, multilocationAllLocations };
};

export default connect(
  mapStateToProps,
  null
)(AtAGlanceLink(canViewAtAGlanceLink));
